import { HttpClient } from "../../apiCalls/httpClient";
import { pgaTypes } from "../components/entrySummaryForms/pga/constantsPGA";
import moment from 'moment'

export const getEntrySummaryForm = (shipId, shipmentType) => {
  const data = {
    eventMessage: {
      ["shipmentId"]: {
        ["id"]: shipId,
      },
      ["shipmentType"]: shipmentType,
    },
    eventType: "GET_B3_FORM",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getK84Date= (shipId) => {
  const data = {
    eventMessage: {
      "shipmentId": shipId
    },
    eventType: "GET_DAILY_NOTICE_DATE",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data,
  });
};

export const getMonthlyStatement= (start,end) => {
  const data = {
    eventMessage: {
      startTime:start,
      endTime:end
    },
    eventType: "GET_CBSA_MONTHLY_TOTALS_FOR_BROKER",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data,
  });
};

export const getDutyAmount= (dutyRate,hsQty) => {
  const data = {
    eventMessage: {
      "dutyRate": dutyRate,
      "hsQty":hsQty
    },
    eventType: "GET_DUTY_AMOUNT_CA",
    eventTime: Date.now()
  };
  return HttpClient.custom({
    data,
  });
};

export const getDIFData = (mrchID) => {
  const data = {
    eventMessage: {
      requestid: mrchID,
    },
    eventType: "GET_DIF_FIELDS_FOR_PGA",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getShipmentNotes = (shipmentId) => {
  const data = {
    eventMessage: {
      shipmentId,
    },
    eventType: "GET_SHIPMENT_NOTES",
    eventTime: Date.now(),
  };

  return HttpClient.custom({
    data,
  });
};

// export const getDropdownValues = (callback) => {
//   const data = {
//     eventMessage: "",
//     eventType: "GET_B3_DROPDOWN_VALUES",
//     eventTime: Date.now(),
//   };
//   return HttpClient.custom({
//     data,
//   });
// };

const newPromise = (_data) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ data: JSON.parse(_data) });
    }, 100);
  });
};

export const getDropdownValues = (callback) => {
  let dropdownVal = sessionStorage.getItem("DROPDOWN_VAL_CBSA");
  if (dropdownVal) {
    return newPromise(dropdownVal);
  }
  const data = {
    eventMessage: "",
    eventType: "GET_B3_DROPDOWN_VALUES",
    eventTime: Date.now(),
  };
  let response = HttpClient.custom({
    data,
  });
  response.then((res) => {
    sessionStorage.setItem("DROPDOWN_VAL_CBSA", JSON.stringify(res.data));
  });
  return response;
};

export const getEntityList = (
  searchValue,
  entityType = "PORT",
  condition = "",
  countryOfDestination
) => {
  const data = {
    eventMessage: {
      entityType,
      searchValue,
      condition,
      countryOfDestination: countryOfDestination,
    },
    eventType: "GET_ENTITY_LIST",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};
export const getFirmListById = (itemId) => {
  const data = {
    eventMessage: {
      country: "CA",
      hsVersion: "2019Rev2.0",
      itemType: "FIRMS_LIST",
      itemId: itemId,
    },
    eventType: "GET_HS_MASTER_HS",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getFirmList = (text, USportOfUnladingCode) => {
  const data = {
    eventMessage: {
      country: "CA",
      hsVersion: "2019Rev2.0",
      itemType: "FIRMS_LIST",
      // province: USportOfUnladingCode.slice(0, USportOfUnladingCode.lastIndexOf(',')),
      firmDesc: text,
    },
    eventType: "GET_HS_MASTER_HS",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getPortDetails = (port) => {
  const data = {
    eventMessage: port.toString(),
    eventType: "GET_PORTS_LOC_DTLS",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getCountryList = () => {
  const data = {
    eventId:
      "ffffffff-875d-6a5f-7b72-bc089d139247----cd11101a-298a-8876-51ed-58e7c7869140",
    eventType: "GET_HS_MASTER_HS",
    eventMessage: {
      country: "CA",
      hsVersion: "2019Rev2.0",
      itemType: "COUNTRY_LIST",
    },
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};
export const getUSStateList = () => {
  const data = {
    eventMessage: {
      country: "US",
      itemType: "PROVINCE_LIST",
      hsVersion: "2019Rev2.0",
      province: "",
    },
    eventType: "GET_HS_MASTER_HS",
    eventTime: 15332404112,
  };

  return HttpClient.custom({
    data,
  });
};
export const getModeOfTransportList = () => {
  const data = {
    eventType: "GET_HS_MASTER_HS",
    eventMessage: {
      country: "US",
      hsVersion: "2019Rev2.0",
      itemType: "MODE_TRANSPORT_TYPE",
      itemId: "",
      itemEdi: "",
    },
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getSCACList = () => {
  const data = {
    eventType: "GET_HS_MASTER_HS",
    eventMessage: {
      country: "US",
      hsVersion: "2019Rev2.0",
      itemType: "SCAC_LIST",
      itemId: "",
      itemEdi: "",
      carrierDesc: "",
    },
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getWarningDetail = (code) => {
  const data = {
    eventType: "GET_CENSUS_WARNING_DETAIL",
    eventMessage: { codes: [code] },
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getTCFormData = (merchandiseId, pgaPayload) => {
  return HttpClient.custom({
    data: getPGAForm({ merchandiseId, formType: pgaTypes.TC, pgaPayload }),
  });
};

export const getECCCFormData = (merchandiseId, pgaPayload) => {
  return HttpClient.custom({
    data: getPGAForm({ merchandiseId, formType: pgaTypes.ECCC, pgaPayload }),
  });
};
export const getInvoiceECCCFormData = (invoiceId, pgaPayload) => {
  return HttpClient.custom({
    data: getInvoicePGAForm({ invoiceId, formType: pgaTypes.ECCC, pgaPayload }),
  });
};
export const getNRCANFormData = (merchandiseId, pgaPayload) => {
  return HttpClient.custom({
    data: getPGAForm({ merchandiseId, formType: pgaTypes.NRCan, pgaPayload }),
  });
};
export const getCFIAFormData = (merchandiseId, pgaPayload) => {
  return HttpClient.custom({
    data: getPGAForm({ merchandiseId, formType: pgaTypes.CFIA, pgaPayload }),
  });
};
export const getCFIAPayorFormData = (merchandiseId, pgaPayload) => {
  return HttpClient.custom({
    data: getPGAPayorForm({
      merchandiseId,
      formType: pgaTypes.CFIA,
      pgaPayload,
    }),
  });
};

export const getTargetPGAForm = (formType, merchandiseId, pgaPayload) => {
  return HttpClient.custom({
    data: getPGAForm({ merchandiseId, formType, pgaPayload }),
  });
};

function getPGAForm({ merchandiseId, formType, pgaPayload }) {
  return {
    eventMessage: {
      shipmentId: window.shipmentId,
      level: 2,
      merchandiseId,
      pgas: [
        {
          cbsaPgaType: pgaPayload.cbsaPgaType,
          cbsaPgaSubProgramType: pgaPayload.cbsaPgaSubProgramType,
        },
      ],
    },
    eventType: "GET_CBSA_PGA_METADATA",
    eventTime: Date.now(),
  };
}
function getPGAPayorForm({ merchandiseId, formType, pgaPayload }) {
  return {
    eventMessage: {
      shipmentId: window.shipmentId,
      level: 0,
      merchandiseId,
      pgas: [
        {
          cbsaPgaType: pgaPayload.cbsaPgaType,
          cbsaPgaSubProgramType: pgaPayload.cbsaPgaSubProgramType,
        },
      ],
    },
    eventType: "GET_CBSA_PGA_METADATA",
    eventTime: Date.now(),
  };
}
function getInvoicePGAForm({ invoiceId, formType, pgaPayload }) {
  return {
    eventMessage: {
      shipmentId: window.shipmentId,

      level: 1,
      invoiceId,
      pgas: [
        {
          cbsaPgaType: pgaPayload.cbsaPgaType,
          cbsaPgaSubProgramType: pgaPayload.cbsaPgaSubProgramType,
        },
      ],
    },
    eventType: "GET_CBSA_PGA_METADATA",
    eventTime: Date.now(),
  };
}

export const onChangeCurrCodeOrDirectShipDate = (
  directShipmentDate,
  currencyCode
) => {
let epoch = Date.UTC(new Date(directShipmentDate).getFullYear(),new Date(directShipmentDate).getMonth(),new Date(directShipmentDate).getDate())
  const data = {
    eventType: "GET_CBSA_EXCHANGE_RATE",
    eventMessage: {
      exchDateEpoch: epoch,
      currencyCode: currencyCode,
    },
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const getFormDataWithURN = (UrnNumber) => {
  const data = {
    eventType: "GET_DIF_REQUEST_FOR_PGA",
    eventMessage: {
      identifier: UrnNumber,
    },
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};
